<ion-item class="full-width ion-item-no-padding" color="light" lines="none">
  <ion-item class="full-width ion-margin-vertical" color="light" lines="none">
    <ion-img class="img-logo" slot="start" src="./assets/wedding/img/logo/app.webp"></ion-img>
    <ion-label class="ion-text-wrap" color="dark">
      {{ 'APP_DOWNLOAD.popover.msg' | translate }}
    </ion-label>
    <ion-button slot="end" (click)="downloadApp()" *ngIf="!facebookApp">{{ 'APP_DOWNLOAD.popover.install' | translate}}</ion-button>
  </ion-item>
</ion-item>
